/**
 * Brand Color Classes - Delegates to Color Registry
 *
 * The Color Registry (registry.ts) is the single source of truth.
 * This file re-exports `getColorClasses` for backward compatibility.
 */

import {getColorClasses} from '@/products/flexible-web-toolkit/colors/registry'

/**
 * Gets brand color classes for Tailwind CSS styling.
 *
 * Delegates entirely to the color registry which handles all colors
 * (including former "custom brand" colors) and alias resolution.
 *
 * @param brandColor - The brand color codename (or alias)
 * @param fallback - Fallback color if brandColor is not found
 * @returns Object with text, bg, border, and hover classes
 */
export function getBrandColorClasses(
	brandColor?: string | null,
	fallback = 'elanco-blue'
): {
	text: string
	bg: string
	border: string
	hover: string
} {
	return getColorClasses(brandColor || fallback, fallback)
}
